import { render } from "./LeaveOurMark.vue?vue&type=template&id=095369d6&scoped=true&ts=true"
import script from "./LeaveOurMark.vue?vue&type=script&lang=ts"
export * from "./LeaveOurMark.vue?vue&type=script&lang=ts"

import "./LeaveOurMark.vue?vue&type=style&index=0&id=095369d6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-095369d6"]])

export default __exports__